<template>
  <div class="page_container userListPage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manageCenterIndex/userManagement' }">业务管理</el-breadcrumb-item>
        <el-breadcrumb-item>成员管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main_container">
      <el-tabs v-model="activeName" @tab-click="handleClickTab">
        <el-tab-pane label="人员管理" name="first">
          <el-table
            :data="tabListOne"
            ref="tableOne"
            height="52vh"
            style="width: 100%"
            @row-click="handleDetail"
            v-loading="loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.4)"
          >
            <!-- <el-table-column prop="accountid" label="账户ID" width="180">
            </el-table-column> -->
            <el-table-column prop="user.truename" label="姓名" width="180">
            </el-table-column>
            <el-table-column
              prop="user.mobile"
              :formatter="formatPhone"
              label="手机号"
              width="180"
            >
            </el-table-column>
            <el-table-column prop="deptname" label="部门" width="180">
            </el-table-column>
            <el-table-column prop="rolename" label="角色"> </el-table-column>
            <el-table-column label="业务关联小程序码">
              <template slot-scope="scope">
                <!-- {{ scope.row.tkid
                }} -->
                <div
                  class="ercode_box"
                  v-if="scope.row.tkid_ercode"
                  @click="handlePictureCardPreview(scope.row.tkid_ercode)"
                >
                  <el-image
                    style="width: 60px; height: 60px"
                    :src="scope.row.tkid_ercode"
                    fit="cover"
                  >
                    <div slot="error" class="image-slot flex-rowc">暂无</div>
                  </el-image>
                </div>

                <!-- <span
                  v-if="scope.row.tkid"
                  class="copy_box"
                  :data-clipboard-text="scope.row.tkid"
                  @click="handleCopyBtn"
                  ><i class="iconfont icon-fuzhi"></i
                ></span> -->
              </template>
            </el-table-column>
            <el-table-column label="合作分润比例%设置">
              <template slot-scope="scope">
                <p>
                  {{
                    scope.row.roleid == 1
                      ? 0
                      : scope.row.profit
                      ? scope.row.profit
                      : 0
                  }}%
                </p>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="joinDate" label="申请时间">
            </el-table-column> -->
            <el-table-column fixed="right" label="操作" width="100">
              <template>
                <el-button type="text" size="small">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 start -->
          <div class="pagination_wrap flex-rowc">
            <el-pagination
              @current-change="handleCurrentChange"
              layout="prev, pager, next, jumper"
              :page-size="10"
              :total="listTotalOne"
            >
            </el-pagination>
          </div>
          <!-- 分页 end -->
        </el-tab-pane>
        <el-tab-pane name="second">
          <template #label>
            <span v-html="labelTwo"></span>
          </template>
          <el-table
            :data="tabListTwo"
            height="57vh"
            ref="tableTwo"
            style="width: 100%"
            @row-click="handleDetail"
          >
            <!-- <el-table-column label="账户ID" width="180">
              <template slot-scope="scope">
                {{scope.row.accountid}}<span class="badge_round"></span>
              </template>
            </el-table-column> -->
            <el-table-column prop="user.truename" label="姓名" width="180">
            </el-table-column>
            <el-table-column
              prop="user.mobile"
              :formatter="formatPhone"
              label="手机号"
              width="180"
            ></el-table-column>
            <!-- <el-table-column prop="attrname" label="用户属性" width="180">
            </el-table-column> -->
            <el-table-column prop="user.levelname" label="用户等级">
            </el-table-column>
            <el-table-column prop="checkdate" label="申请时间">
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template>
                <el-button type="text" size="small">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 start -->
          <div class="pagination_wrap flex-rowc">
            <el-pagination
              @current-change="handleCurrentChange"
              layout="prev, pager, next, jumper"
              :page-size="10"
              :total="listTotalTwo"
            >
            </el-pagination>
          </div>
          <!-- 分页 end -->
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog :visible.sync="dialogVisible">
      <!-- <img width="100%" :src="dialogImageUrl" alt="" /> -->
      <div class="flex-rowc">
        <el-image
          style="width: 180px; height: 180px"
          :src="dialogImageUrl"
          fit="cover"
        ></el-image>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import { encryptstringview, encryptstringadd } from "../../api/api";
import { getApplyCompanyList } from "../../api/company";
import { mapState } from "vuex";
export default {
  name: "userList",
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,

      loading: false,
      activeName: "first",
      tabListOne: [],
      listTotalOne: 0,
      labelTwo: "加入申请",
      tabListTwo: [],
      listTotalTwo: 0,

      params: {
        pageindex: 1,
        pagesize: 10,
        keyword: "",
        qyid: "",
        checkstate: 1, // 审核状态 = 0审核中 1已通过 2拒绝加入 3已退出 4已被移出
      },
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { qyid } = JSON.parse(res.jsondata);
        this.params.qyid = qyid;
        this.getApplyCompanyList();
      } else {
        this.$router.back();
      }
    },

    // 手机号隐藏四位
    formatPhone(row) {
      const phone = row.user.mobile;
      let hiddenPhone = "";
      if (phone.length === 11) {
        hiddenPhone = phone.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
      }

      return hiddenPhone;
    },

    // 动态添加标记
    renderHTML() {
      // `<span>加入申请</span>`+
      const newLabel = `<span>加入申请${
        this.tabListTwo.length > 0
          ? '<span class="badge">new</span></span>'
          : ""
      }`;
      this.labelTwo = newLabel;
    },

    handleClickTab(tab) {
      let name = tab.name;
      if (name == "first") {
        this.params.checkstate = 1;
        this.getApplyCompanyList();
        this.$nextTick(() => {
          this.$refs.tableOne.doLayout();
        });
      } else if (name == "second") {
        this.params.checkstate = 0;
        this.$nextTick(() => {
          this.$refs.tableTwo.doLayout();
        });
        this.getApplyCompanyList();
      }
    },
    getApplyCompanyList() {
      let { params, activeName } = this;
      this.loading = true;
      getApplyCompanyList(params).then((res) => {
        console.log(res, "===----res");

        if (activeName == "first") {
          this.tabListOne = res.list;
          this.listTotalOne = res.total;
        } else if (activeName == "second") {
          this.tabListTwo = res.list;
          this.listTotalTwo = res.total;
          this.renderHTML();
        }
        this.loading = false;
        // res.forEach((v) => {
        //   v.joinDate =
        //     v.checkdate.split("T")[0] + " " + v.checkdate.split("T")[1];
        //   v.levelname = v.user.levelname;
        //   v.attrname = v.user.attrname;
        //   if (v.checkstate == 1) {
        //     this.tabListOne.push(v);
        //   }
        //   if (v.checkstate == 0) {
        //     this.tabListTwo.push(v);
        //     this.renderHTML();
        //   }
        // });
      });
    },
    // 分页
    handleCurrentChange(e) {
      this.params.pageindex = e;
      this.getApplyCompanyList();
    },

    handleDetail(e, event) {
      if (event.label == "业务关联小程序码") {
        return;
      } else {
        let { qyid } = this.params;
        // this.$router.push(`/companyIndex/userDetail/${e.openid}/${qyid}/${e.id}`);
        this.encryptstringadd("userDetail", {
          openid: e.openid,
          qyid,
          id: e.id,
        });
      }
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
          // window.open(this.$router.resolve({ name, params }).href, '_blank');
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    // 大图预览
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        console.log("复制成功");
        this.$message.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$message.warning("复制失败");
        } else {
          // this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.userListPage {
  .main_container {
    margin: 20px auto;
    .ercode_box {
      margin-left: 25px;
      cursor: pointer;
    }
    .copy_box {
      cursor: pointer;
      margin-left: 10px;
    }
    .el-image__error {
      font-size: 10px;
    }
  }
  /deep/ .el-tabs__item {
    position: relative;
    .badge {
      position: absolute;
      font-size: 12px;
      color: red;
      top: -8px;
    }
  }
  /deep/ .el-table .cell {
    position: relative;
    .badge_round {
      display: inline-block;
      width: 5px !important;
      height: 5px !important;
      border-radius: 50%;
      background: red;
      position: absolute;
      top: 3px;
    }
  }
}
</style>